import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import testi1 from '../../../assets/images/testi1.png';
import testi2 from '../../../assets/images/testi2.png';
import testi3 from '../../../assets/images/testi3.png';

const testimonials = [
  {
    img: testi1,
    text: "I’m extremely careful about what I eat—and Ariha’s Low GI breads have become a non-negotiable part of my diet. The multigrain seeded loaf is packed with fiber and actually keeps me full till lunchtime. No bloating, no energy crashes, just clean, wholesome eating. It’s bread I can trust!",
  },
  {
    img: testi2,
    text: "With two kids and a hectic work life, I barely have time to cook elaborate breakfasts. Ariha’s Spiced Low GI loaf has been a lifesaver. I just toast it, add some hummus or veggies, and I’m good to go. It’s healthy, filling, and actually delicious. Can’t recommend it enough!",
  },
  {
    img: testi3,
    text: "Finding a bread that doesn’t spike my sugar has always been a challenge. Ariha's Salted Low GI loaf has changed the game for me. It tastes great, doesn’t mess with my glucose levels, and stays fresh without refrigeration. It’s a relief to finally enjoy toast again—without the worry.",
  },
];

const Testimonials = () => (
  <Container className='cards my-5'>
    <h2 className='text-start'>Customer Testimonials </h2>
    <Row>
      {testimonials.map((t, idx) => (
        <Col md={4} xs={12} key={idx}>
          <Card className='text-start p-3'>
            <Card.Body>
              <div className='mb-2'>
                <i className="fas fa-quote-left fa-lg text-muted"></i>
              </div>
              <Card.Text>{t.text}</Card.Text>
              <div className='d-flex align-items-center justify-content-between mt-3'>
                <Card.Img
                  src={t.img}
                  alt="logo"
                  style={{ width: '60px', height: '60px', borderRadius: '100px' }}
                  className='me-3'
                />
                <div className='d-flex align-items-center'>
                  <i className="fas fa-star text-warning me-1"></i>
                  <i className="fas fa-star text-warning me-1"></i>
                  <i className="fas fa-star text-warning me-1"></i>
                  <i className="fas fa-star-half-alt text-warning me-1"></i>
                  <i className="far fa-star text-warning"></i>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </Container>
);

export default Testimonials;